(function () {
  "use strict";

  /* Responsive videos
    /* ---------------------------------------------------------- */
  var defined = typeof reframe !== "undefined";
  if (defined) {
    reframe(
      document.querySelectorAll(
        [
          '.post-content iframe[src*="youtube.com"]',
          '.post-content iframe[src*="youtube-nocookie.com"]',
          '.post-content iframe[src*="player.vimeo.com"]',
          '.post-content iframe[src*="kickstarter.com"]',
          ".post-content object",
          ".post-content embed",
        ].join(","),
      ),
    );
  }

  /* Responsive tables
    /* ---------------------------------------------------------- */
  var tables = document.querySelectorAll(".post-content > table:not(.gist table)");
  for (var i = 0; i < tables.length; i++) {
    var table = tables[i];
    // Editorial pages have their own idempotent, accessible table adapter.
    if (table.closest(".blog-post, .blog-page")) continue;
    var wrapper = document.createElement("div");
    wrapper.className = "table-wrapper";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }

  /* Japanese date format (YYYY年M月D日)
    /* ---------------------------------------------------------- */
  if (document.documentElement.lang === "ja") {
    var dates = document.querySelectorAll("time.js-date[datetime]");
    for (var d = 0; d < dates.length; d++) {
      var parts = dates[d].getAttribute("datetime").split("-");
      dates[d].textContent =
        parseInt(parts[0], 10) + "年" + parseInt(parts[1], 10) + "月" + parseInt(parts[2], 10) + "日";
    }
  }

  /* Updated date visibility
    /* ---------------------------------------------------------- */
  var updatedElements = document.querySelectorAll("[data-published][data-updated]");
  for (var u = 0; u < updatedElements.length; u++) {
    if (updatedElements[u].dataset.published === updatedElements[u].dataset.updated) {
      updatedElements[u].style.display = "none";
    }
  }

  /* Infinite scroll
    /* ---------------------------------------------------------- */
  var sentinel = document.querySelector(".infinite-scroll-sentinel");
  if (sentinel) {
    var grid = document.querySelector(".post-grid");
    var loading = false;

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !loading) {
          loadNextPage();
        }
      },
      { rootMargin: "200px" },
    );
    observer.observe(sentinel);

    function loadNextPage() {
      var nextUrl = sentinel.dataset.next;
      if (!nextUrl) return;

      loading = true;
      var loader = document.createElement("div");
      loader.className = "infinite-scroll-loader";
      sentinel.parentNode.insertBefore(loader, sentinel);

      fetch(nextUrl)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var cards = doc.querySelectorAll(".post-card");
          for (var c = 0; c < cards.length; c++) {
            grid.appendChild(cards[c]);
          }

          // reformat dates for new cards (Japanese locale)
          if (document.documentElement.lang === "ja") {
            var newDates = grid.querySelectorAll(".post-card:not([data-processed]) time.js-date[datetime]");
            for (var nd = 0; nd < newDates.length; nd++) {
              var dp = newDates[nd].getAttribute("datetime").split("-");
              newDates[nd].textContent =
                parseInt(dp[0], 10) + "年" + parseInt(dp[1], 10) + "月" + parseInt(dp[2], 10) + "日";
            }
          }

          // hide updated dates where published === updated (for new cards)
          var newUpdated = grid.querySelectorAll(".post-card:not([data-processed]) [data-published][data-updated]");
          for (var n = 0; n < newUpdated.length; n++) {
            if (newUpdated[n].dataset.published === newUpdated[n].dataset.updated) {
              newUpdated[n].style.display = "none";
            }
          }

          var nextSentinel = doc.querySelector(".infinite-scroll-sentinel");
          if (nextSentinel) {
            sentinel.dataset.next = nextSentinel.dataset.next;
          } else {
            delete sentinel.dataset.next;
            observer.unobserve(sentinel);
            sentinel.remove();
          }

          loader.remove();
          loading = false;
        })
        .catch(function () {
          loader.remove();
          loading = false;
        });
    }
  }
})();
